// src/components/PodcastCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import './PodcastCard.css';

const PodcastCard = ({ podcast }) => {
  return (
    <Link to={`/podcast/${podcast.id}`} className="podcast-card-link">
      <div className="podcast-card">
        <img
          src={podcast.image || podcast.artwork || 'https://via.placeholder.com/160?text=No+Image'}
          alt={podcast.title}
          className="podcast-card-image"
        />
        <h3 className="podcast-card-title" title={podcast.title}>
          {podcast.title}
        </h3>
        <p className="podcast-card-author" title={podcast.author}>
          {podcast.author || 'N/A'}
        </p>
      </div>
    </Link>
  );
};

export default PodcastCard;
